import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { cn } from '@/shared/lib';
import type {
  SheetDescriptionProps,
  SheetSectionProps,
  SheetTitleProps,
} from '@/shared/ui/sheet/types';
import { sheetStyles } from '@/shared/ui/sheet/styles';

/**
 * Title, description and layout sections.
 *
 * `SheetTitle` is the accessible name the panel is announced by, so a sheet
 * without one is announced as an unnamed dialog.
 */
export function SheetTitle({ className, ...props }: SheetTitleProps) {
  return <DialogPrimitive.Title className={cn(sheetStyles.title, className)} {...props} />;
}

export function SheetDescription({ className, ...props }: SheetDescriptionProps) {
  return (
    <DialogPrimitive.Description className={cn(sheetStyles.description, className)} {...props} />
  );
}

export function SheetHeader({ className, ...props }: SheetSectionProps) {
  return <div className={cn(sheetStyles.header, className)} {...props} />;
}

export function SheetBody({ className, ...props }: SheetSectionProps) {
  return <div className={cn(sheetStyles.body, className)} {...props} />;
}

export function SheetFooter({ className, ...props }: SheetSectionProps) {
  return <div className={cn(sheetStyles.footer, className)} {...props} />;
}